import dynamic from "next/dynamic";
import Head from "next/head";
import React, { useEffect } from "react";
import { FrontPagesCTA, FrontPagesFooter, FrontPagesLearnMore } from "../components/front-pages/commons";
import AnimatedHeaderText from "../components/front-pages/commons/animated-header-text";
import FrontPagesLayout from "../components/front-pages/front-pages-layout";
import { HomePageFeatures, HomePageItemsToSell, HomePageHeader } from "../components/front-pages/home-page";
import { PricingTestimonials } from "../components/front-pages/pricing";
import { PageTags } from "../components/seo-tags";
import PagesLoaderContext from "../contexts/page-loader-context";
import { GetServerSideProps } from "next";
import fetchStoreData from "@/assets/js/utils/fetch-store-data";
import { NotFoundMain } from "./404";
import fetchStoreByDomain from "@/assets/js/utils/fetch-store-by-domain";
import StoreFrontV2, { StoreFrontProps } from "@/components/storefronts-v2";
import { STORE_VERSION } from "@/assets/interfaces";
import StoreFrontV1 from "@/components/storefronts-v1/root";
import StorefrontContext, { VisitRoute } from "@/contexts/storefront";
import { domainServerSideProps } from "@/assets/js/store-server-side-props";
const pageTags: PageTags = {
  title: "Catlog - Sell Easily On Social Media",
  description:
    "Catlog gives businesses the tools to take orders via chat, manage their orders & customers, collect payments easily and deliver items without hassle",
  pageUrl: "/",
  image: "https://res.cloudinary.com/catlog/image/upload/v1671181798/seo-banners/Main_Banner.png",
};

interface PageProps {
  config: "store" | "landing";
  data?: StoreFrontProps;
}

const HomePage: React.FC<PageProps> = (props) => {
  const { config, data } = props;

  if (config === "landing") {
    return <LandingPage />;
  }

  if (!data || !data.data.store) {
    return <NotFoundMain />;
  }

  return (
    <StorefrontContext.Provider
      initialState={{ route: data?.visitRoute ?? VisitRoute.SUB_DOMAIN, store: data.data?.store }}
    >
      {data.data?.store?.flags?.storefront_version === STORE_VERSION.V1 ? (
        <StoreFrontV1 {...data} />
      ) : (
        <StoreFrontV2 {...data} />
      )}
    </StorefrontContext.Provider>
  );
};

const LandingPage = () => {
  return (
    <PagesLoaderContext.Provider>
      <FrontPagesLayout tags={pageTags}>
        <Head>
          <link rel="icon" href="/favicon.png" type="image/png" />
          <link
            rel="preload"
            as="image"
            href=""
            imageSrcSet="https://res.cloudinary.com/catlog/image/upload/c_scale,w_750/v1670354764/front-pages/woman-with-cup.webp 750w, https://res.cloudinary.com/catlog/image/upload/c_scale,w_1200/v1670354764/front-pages/woman-with-cup.webp 1200w"
            sizes="(max-width: 520px) 750px, 1200px"
          ></link>
        </Head>
        <main>
          <HomePageHeader />
          <HomePageFeatures />
          <PricingTestimonials whiteBg />
          <HomePageItemsToSell />
          <FrontPagesLearnMore />
          <FrontPagesCTA className="primary-cta">
            <AnimatedHeaderText
              series={[
                ["Get", "started", "in"],
                ["5", "minutes"],
              ]}
              className="!leading-[1]"
            />
          </FrontPagesCTA>
          <FrontPagesFooter />
        </main>
      </FrontPagesLayout>
    </PagesLoaderContext.Provider>
  );
};

export const getServerSideProps: GetServerSideProps = domainServerSideProps;

export default HomePage;
